import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Nisab from './pages/Nisab';
import Zakat from './pages/Zakat';
import ZakatCalculator from './pages/ZakatCalculator';
import About from './pages/About';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="App d-flex flex-column min-vh-100">
      {/* Navbar */}
      <nav className="navbar navbar-expand-md navbar-light bg-light fixed-top">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="/assets/img/IA-Logo-10.1.2021.png" height="30" className="d-inline-block align-top" alt="Islam Answers" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarsExampleDefault">
            <ul className="navbar-nav me-auto">
              <li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className={`nav-item ${location.pathname === '/zakat' || location.pathname === '/zakat/calculator' ? 'active' : ''}`}>
                <Link className="nav-link" to="/zakat">Zakat</Link>
              </li>
              <li className={`nav-item ${location.pathname === '/nisab' ? 'active' : ''}`}>
                <Link className="nav-link" to="/nisab">Nisab</Link>
              </li>
              <li className={`nav-item ${location.pathname === '/about' ? 'active' : ''}`}>
                <Link className="nav-link" to="/about">About</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main role="main">
        {/* Carousel Banner - Only on Home Page */}
        {isHome && (
          <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
            <ol className="carousel-indicators">
              <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active"></li>
            </ol>
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img className="d-block w-100" src="/assets/img/banner04.jpg" alt="Zakat Banner" />
                <div className="container">
                  <div className="carousel-caption">
                    <h1>Zakat</h1>
                    <p>
                      Zakat is one of the 5 pillars of Islam and an important obligation upon all Muslims who meet the criteria of Nisab.
                    </p>
                    <p>
                      <Link className="btn btn-lg btn-success" to="/zakat/calculator" role="button">
                        Zakat Calculator
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        )}

        {/* Add spacing for non-home pages */}
        {!isHome && <br />}

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nisab" element={<Nisab />} />
          <Route path="/zakat" element={<Zakat />} />
          <Route path="/zakat/calculator" element={<ZakatCalculator />} />
          <Route path="/about" element={<About />} />
        </Routes>

        {/* Footer */}
        <footer className="mt-auto">
          <div className="container">
            <div className="row">
              <div className="col-md">
                <h5>Services</h5>
                <ul className="list-unstyled text-small">
                  <li><Link className="text-muted" to="/zakat">Zakat Calculator</Link></li>
                  <li><Link className="text-muted" to="/nisab">Nisab Calculator</Link></li>
                  <li><a className="text-muted" href="https://prayertimes.islamanswers.co.uk">Prayer Times</a></li>
                </ul>
              </div>
              <div className="col-md">
                <h5>About Islam Answers</h5>
                <ul className="list-unstyled text-small">
                  <li><Link className="text-muted" to="/about">About</Link></li>
                  <li><a className="text-muted" href="https://www.islamanswers.co.uk/nextstep">The Next Step</a></li>
                </ul>
              </div>
              <div className="col-md socials">
                <h5>FOLLOW US</h5>
                <a href="https://www.facebook.com/islamanswers2020" className="fa fa-facebook" aria-label="Facebook"></a>
                <a href="https://twitter.com/islamanswers20" className="fa fa-twitter" aria-label="Twitter"></a>
                <a href="https://www.instagram.com/IslamAnswers.co.uk" className="fa fa-instagram" aria-label="Instagram"></a>
                <a href="https://www.youtube.com/islamanswers2020" className="fa fa-youtube" aria-label="YouTube"></a>
                <a href="https://www.reddit.com/r/IslamAnswers" className="fa fa-reddit" aria-label="Reddit"></a>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
